import React from 'react';
import { flowRight as compose } from 'lodash';
import { Link } from 'react-router-dom';

import staticPageStyles from '../StaticPages/StaticPage.module.scss';
import withAccessTracker from '../AccessTracker';
import { withSEO } from '../SEO/withSEO';
import {
  trackingAllowed,
  onTrackingConsentChange,
  openConsentSettings,
} from '../../util/trackingConsent';

class DataProtectionInfoScreen extends React.Component {
  // eslint-disable-next-line react/state-in-constructor
  state: any;

  static defaultProps = {
    meData: null,
    userItestResults: null,
  };

  unsubscribe: (() => void) | null = null;

  constructor(props: any) {
    super(props);

    this.state = {
      trackingDataAccepted: trackingAllowed(),
    };
  }

  componentDidMount() {
    // keep the displayed choice in sync when the visitor changes it in Usercentrics
    this.unsubscribe = onTrackingConsentChange((allowed) => {
      this.setState({ trackingDataAccepted: allowed });
    });
  }

  componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
  }

  render() {
    const { trackingDataAccepted } = this.state;

    const yourChoice = trackingDataAccepted
      ? 'Du hast Tracking gewählt.'
      : 'Tracking ist nicht aktiv.';

    return (
      <div className={staticPageStyles.staticPage} data-nosnippet>
        <div className={staticPageStyles.card}>
          <div className={staticPageStyles.cardHeader}>
            <h1>INFORMATIONEN ZUR DATENVERARBEITUNG</h1>
          </div>
          <div className={staticPageStyles.cardContent}>
            <p>
              Gemäß Artikel 13 und 14 der Datenschutzgrundverordnung (DSGVO) ist
              Datenschutz Vertrauenssache und dein Vertrauen ist uns wichtig. Es
              ist uns daher ein Anliegen, transparent zu arbeiten und dabei
              deine berechtigten Interessen auf Geheimhaltung deiner
              personenbezogenen Daten zu schützen. Deshalb informieren wir dich
              mit dieser Datenschutzerklärung, wie wir mit deinen Daten umgehen.
            </p>
            <p>
              <h2>Technische Informationen zum Internetauftritt</h2>
              {/* eslint-disable-next-line prettier/prettier */}
              <Link to="/" target="_blank" rel="noopener noreferrer">
                www.jopsy.at
              </Link>{' '}
              wird von der Kammer für Arbeiter und Angestellte für Wien als Büro
              der Bundesarbeitskammer, Prinz-Eugen-Straße 20-22, Telefon: +43 1
              501 65-0, E-Mail:{' '}
              <a href="mailto: impressum@akwien.at">impressum@akwien.at</a> als
              Diensteanbieter betrieben.
            </p>
            <p>
              <h2>Medieninhaber und Herausgeber</h2>
              Medieninhaber und Herausgeber der Website{' '}
              {/* eslint-disable-next-line prettier/prettier */}
              <Link to="/" target="_blank" rel="noopener noreferrer">
                www.jopsy.at
              </Link>{' '}
              ist die Kammer für Arbeiter und Angestellte für Wien als
              Bundesarbeitskammer.
            </p>
            <p>
              Den Datenschutzbeauftragen der Bundesarbeitskammer kannst du unter{' '}
              <a href="mailto:datenschutz@akwien.at">datenschutz@akwien.at</a>{' '}
              erreichen.
            </p>
            <p>
              <h2>
                Wo und wofür verarbeitet die AK deine personenbezogenen Daten?
              </h2>
              Die Bundesarbeitskammer speichert dein Passwort und deine
              Abfrageergebnisse von der Website auf ihrem Server, damit du immer
              Zugriff auf deine auf der Website erzielten Ergebnisse hast.
              Rechtsgrundlagen dafür sind die „Einwilligung der betroffenen
              Person“ gem. Art 6 Abs 1 lit. a) DSGVO sowie die „Erfüllung eines
              Vertrages“ gem. Art 6 Abs 1 lit. b) DSGVO.
            </p>
            <p>
              <h2>Deine Auswahl</h2>
              {yourChoice}
              <br />
              <br />
              <div>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={openConsentSettings}
                >
                  Cookie Einstellungen ändern
                </button>
              </div>
            </p>
            <p>
              <h2>Löschung der Daten</h2>
              Du hast das Recht, deinen Account jederzeit ohne Angabe von
              Gründen löschen zu lassen, indem du dich mit dem Ersuchen um
              Löschung deines Accounts an{' '}
              <a href="mailto: impressum@akwien.at">impressum@akwien.at</a>{' '}
              wendest. Dein Account wird jedenfalls 3 Jahre nach der ersten
              Registrierung gelöscht.
            </p>
            <p>
              Die Bundesarbeitskammer weist dich darauf hin, dass du bezüglich
              deiner Daten ein Recht auf Auskunft, Berichtigung, Löschung,
              Einschränkung der Verarbeitung, Datenübertragbarkeit (Art. 15-21
              DSGVO), sowie auf Beschwerde bei der Datenschutzbehörde hast (Art.
              77 DSGVO). Die Einwilligung zur Speicherung der Daten kann
              jederzeit widerrufen werden (Art. 6 Abs. 2 DSGVO).
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  withSEO({
    title: 'Jopsy | Alles zum Datenschutz',
    description:
      'Erfahre alles über dein Schutz und die Geheimhaltung deiner personenbezogenen Daten.',
  }),
  withAccessTracker('Datenschutz'),
)(DataProtectionInfoScreen);
